<template>
    <article>
        <p>
            This inspection shows whether there are messages with the ERROR and WARNING severities in the application logs.
        </p>

        <v-card>
            <v-img eager src="/static/img/docs/coroot-ce/inspections/logs.png" />
        </v-card>
        
    </article>
</template>

<script>

export default {
}
</script>

<style scoped>
</style>
